// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./FiveDysfunctionPyramid.css";


// const pyramidConfig = [
//   { full: "Inattention to Results", short: "RESULTS" },
//   { full: "Avoidance of Accountability", short: "ACCOUNTABILITY" },
//   { full: "Lack of Commitment", short: "COMMITMENT" },
//   { full: "Fear of Conflict", short: "CONFLICT" },
//   { full: "Absence of Trust", short: "TRUST" }
// ];


// export default function FiveDysfunctionPyramid({ surveyId, companyId }) {
//   const [analytics, setAnalytics] = useState(null);
//   const [selectedGroup, setSelectedGroup] = useState(null);

//   useEffect(() => {
//     fetchData();
//   }, [surveyId, companyId]);

//   const fetchData = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/superadmin/analytics/score/${surveyId}/${companyId}`
//       );
//       setAnalytics(res.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const getColor = (avg) => {
//     if (avg < 3) return "#E53935";   // RED
//     if (avg < 4) return "#F4D03F";   // YELLOW
//     return "#1E8449";                // GREEN
//   };

//   if (!analytics) return <div>Loading...</div>;

//   const height = 520;
//   const width = 720;
//   const bandHeight = height / 5;

//   const getGradient = (avg) => {
//   if (avg < 3)
//     return "linear-gradient(90deg, #ff6b6b, #e53935)";
//   if (avg < 4)
//     return "linear-gradient(90deg, #f9d976, #f4d03f)";
//   return "linear-gradient(90deg, #2ecc71, #1e8449)";
// };

// // Flatten all questions
// const allQuestions = analytics
//   ? Object.entries(analytics).flatMap(([groupName, groupData]) =>
//       groupData.questions.map(q => ({
//         ...q,
//         group_name: groupName
//       }))
//     )
//   : [];

// // Top 6 strongest
// const strongest = [...allQuestions]
//   .sort((a, b) => b.average - a.average)
//   .slice(0, 6);

// // Bottom 6 weakest
// const weakest = [...allQuestions]
//   .sort((a, b) => a.average - b.average)
//   .slice(0, 6);

// const AnimatedNumber = ({ value }) => {
//   const [display, setDisplay] = React.useState(0);

//   React.useEffect(() => {
//     let start = 0;
//     const duration = 800;
//     const increment = value / (duration / 16);

//     const counter = setInterval(() => {
//       start += increment;
//       if (start >= value) {
//         start = value;
//         clearInterval(counter);
//       }
//       setDisplay(start);
//     }, 16);

//     return () => clearInterval(counter);
//   }, [value]);

//   return display.toFixed(2);
// };

// // ================= KEY DIFFERENCES =================

// const keyDifferences = allQuestions.filter(q => {

//   const c = q.counts;

//   const left =
//     c.almost_never +
//     c.rarely;

//   const right =
//     c.usually +
//     c.almost_always;

//   const center = c.sometimes;

//   const total =
//     left + right + center;

//   if (!total) return false;

//   const leftPct = left / total;
//   const rightPct = right / total;

//   // Rule 1: 50/50 split
//   const rule1 =
//     Math.abs(leftPct - rightPct) <= 0.1;

//   // Rule 2: 60/40 disagreement
//   const rule2 =
//     (leftPct >= 0.4 && leftPct <= 0.6) ||
//     (rightPct >= 0.4 && rightPct <= 0.6);

//   // Rule 3: extreme ends present
//   const rule3 =
//     c.almost_never > 0 &&
//     c.almost_always > 0;

//   // Rule 4: outliers
//   const rule4 =
//     (leftPct >= 0.8 && rightPct >= 0.1) ||
//     (rightPct >= 0.8 && leftPct >= 0.1);

//   return rule1 || rule2 || rule3 || rule4;

// }).slice(0,6);

//   return (
//     <div style={{ marginTop: 40, width: "100%" }}>

//       {/* ================= COLOR LEGEND ================= */}


//       {/* ================= PYRAMID + SCORE LEGEND ================= */}
// {/* <div style={{
//   width: "100%",
//   maxWidth: 520,
//   aspectRatio: "1 / 1",
//   margin: "0 auto"
// }}> */}

//           <div style={{
//         display: "flex",
//         justifyContent: "center",
//         gap: 60,
//         marginBottom: 20,
//         fontWeight: 600,
//         fontSize: 14
//       }}>
//         <LegendItem color="#E53935" label="LOW (LESS THAN 3)" />
//         <LegendItem color="#F4D03F" label="MEDIUM (3 – 3.99)" />
//         <LegendItem color="#1E8449" label="HIGH (4 & ABOVE)" />
//       </div>
// <div className="pyramid-dashboard">

//       <div className="pyramid-left">
//       {/* ===== PYRAMID ===== */}
// <svg
//   viewBox="0 0 720 520"
//   width="520"
//   height="520"
//     preserveAspectRatio="xMidYMid meet"
//   >

//     {/* Glow filter */}
//     <defs>
//       <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
//         <feGaussianBlur stdDeviation="6" result="blur" />
//         <feMerge>
//           <feMergeNode in="blur" />
//           <feMergeNode in="SourceGraphic" />
//         </feMerge>
//       </filter>
//     </defs>

//     {pyramidConfig.map((item, i) => {
//       const avg = Number(
//         analytics[item.full]?.group_metrics?.average || 0
//       );

//       const height = 520;
//       const width = 720;
//       const bandHeight = height / 5;

//       const yTop = i * bandHeight;
//       const yBottom = (i + 1) * bandHeight;

//       const widthTop = (yTop / height) * width;
//       const widthBottom = (yBottom / height) * width;

//       const xTopLeft = (width - widthTop) / 2;
//       const xTopRight = xTopLeft + widthTop;

//       const xBottomLeft = (width - widthBottom) / 2;
//       const xBottomRight = xBottomLeft + widthBottom;

//       const gradientId = `grad-${i}`;

//       return (
//         <g key={item.full}>

//           {/* Gradient definition */}
//           <defs>
//             <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
//               {avg < 3 && (
//                 <>
//                   <stop offset="0%" stopColor="#ff6b6b" />
//                   <stop offset="100%" stopColor="#e53935" />
//                 </>
//               )}
//               {avg >= 3 && avg < 4 && (
//                 <>
//                   <stop offset="0%" stopColor="#f9d976" />
//                   <stop offset="100%" stopColor="#f4d03f" />
//                 </>
//               )}
//               {avg >= 4 && (
//                 <>
//                   <stop offset="0%" stopColor="#2ecc71" />
//                   <stop offset="100%" stopColor="#1e8449" />
//                 </>
//               )}
//             </linearGradient>
//           </defs>

//           <polygon
//             points={`
//               ${xTopLeft},${yTop}
//               ${xTopRight},${yTop}
//               ${xBottomRight},${yBottom}
//               ${xBottomLeft},${yBottom}
//             `}
//             fill={`url(#${gradientId})`}
//             stroke="white"
//             strokeWidth="4"
//             style={{
//               transition: "all 0.4s ease",
//               filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.12))"
//             }}
//             className="pyramid-slice"
//           />

//           <text
//             x={width / 2}
//             y={yTop + bandHeight / 1.2}
//             textAnchor="middle"
//             dominantBaseline="middle"
//             fill="#ffffff"
//             fontSize="20"
//             fontWeight="700"
//             letterSpacing="1"
//             style={{
//               pointerEvents: "none"
//             }}
//           >
//             {item.short}
//           </text>
//         </g>
//       );
//     })}
//   </svg>
//   </div>

//         {/* ===== SCORE LEGEND ===== */}
//      {/* ===== SCORE LEGEND ===== */}
// {/* ===== PREMIUM SCORE LEGEND ===== */}
//  <div className="pyramid-right">
// <div style={{
//   minWidth: 300,
//   background: "#ffffff",
//   padding: "24px",
//   borderRadius: 16,
//   boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
//   transition: "all 0.3s ease"
// }}>

//   {/* ===== OVERALL HEALTH BADGE ===== */}
//   {(() => {
//     const averages = pyramidConfig.map(item =>
//       Number(analytics[item.full]?.group_metrics?.average || 0)
//     );

//     const overall =
//       averages.reduce((a, b) => a + b, 0) / averages.length;

//     const overallColor =
//       overall < 3 ? "#E53935" :
//       overall < 4 ? "#F4D03F" :
//       "#1E8449";

//     return (
//       <div style={{
//         textAlign: "center",
//         marginBottom: 24
//       }}>
//         {/* <div style={{
//           fontSize: 13,
//           fontWeight: 600,
//           opacity: 0.6,
//           marginBottom: 6
//         }}>
//           OVERALL HEALTH
//         </div> */}

//         {/* <div style={{
//           fontSize: 28,
//           fontWeight: 800,
//           color: overallColor
//         }}>
//           <AnimatedNumber value={overall} />
//         </div> */}
//       </div>
//     );
//   })()}

//   {/* ===== SECTION SCORES ===== */}
//   {pyramidConfig.map(item => {
//     const avg = Number(
//       analytics[item.full]?.group_metrics?.average || 0
//     );

//     const percentage = (avg / 5) * 100;

//     return (
//       <div
//         key={item.full}
//         style={{
//           marginBottom: 18,
//           padding: "10px 12px",
//           borderRadius: 10,
//           transition: "all 0.25s ease",
//           cursor: "default"
//         }}
//         onMouseEnter={e =>
//           (e.currentTarget.style.background = "rgba(0,0,0,0.03)")
//         }
//         onMouseLeave={e =>
//           (e.currentTarget.style.background = "transparent")
//         }
//       >
//         {/* Label + Value */}
//         <div style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginBottom: 6,
//           fontWeight: 600
//         }}>
//           <span>{item.short}</span>
//           <span style={{ fontWeight: 700 }}>
//             <AnimatedNumber value={avg} />
//           </span>
//         </div>

//         {/* Progress Bar */}
//         <div style={{
//           height: 8,
//           width: "100%",
//           background: "#eee",
//           borderRadius: 6,
//           overflow: "hidden"
//         }}>
//           <div style={{
//             height: "100%",
//             width: `${percentage}%`,
//             background: getGradient(avg),
//             transition: "width 0.8s ease"
//           }} />
//         </div>
//       </div>
//     );
//   })}
// </div>
//   </div>

//       </div>

//       {/* ================= STRONGEST AREAS ================= */}
// <div style={{ marginTop: 60 }}>
//   <h2 style={{ marginBottom: 20 }}>The Strongest Areas</h2>

//   {strongest.map((q, i) => (
//     <div key={q.question_id} style={{ marginBottom: 18 }}>
//       <div><b>{i + 1}. {q.question_text}</b></div>

//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         background: "#f3f4f6",
//         padding: "6px 12px",
//         marginTop: 6
//       }}>
//         <span>BEHAVIOR: {q.group_name}</span>
//         <span>AVG SCORE: {q.average.toFixed(2)}</span>
//       </div>
//     </div>
//   ))}
// </div>

// {/* ================= WEAKEST AREAS ================= */}
// <div style={{ marginTop: 60 }}>
//   <h2 style={{ marginBottom: 20 }}>The Weakest Areas</h2>

//   {weakest.map((q, i) => (
//     <div key={q.question_id} style={{ marginBottom: 18 }}>
//       <div><b>{i + 1}. {q.question_text}</b></div>

//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         background: "#fef2f2",
//         padding: "6px 12px",
//         marginTop: 6
//       }}>
//         <span>BEHAVIOR: {q.group_name}</span>
//         <span>AVG SCORE: {q.average.toFixed(2)}</span>
//       </div>
//     </div>
//   ))}
// </div>

// {/* ================= KEY DIFFERENCES ================= */}



// <div style={{ marginTop: 70 }}>
//   <h2 style={{ marginBottom: 25 }}>
//     Key Differences
//   </h2>

//   {keyDifferences.map((q, i) => {

//     const c = q.counts;

//     return (
//       <div key={q.question_id} className="keydiff-question">

//         <div>
//           <b>{i + 1}. {q.question_text}</b>
//         </div>

//         <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
// Number of team members in each category
// </div>

//         <div className="keydiff-counts">

//           <div className="keydiff-count-box">
//             <div className="keydiff-count-value">
//               {c.almost_never}
//             </div>
//             <div className="keydiff-count-label">
//               ALMOST NEVER
//             </div>
//           </div>

//           <div className="keydiff-count-box">
//             <div className="keydiff-count-value">
//               {c.rarely}
//             </div>
//             <div className="keydiff-count-label">
//               RARELY
//             </div>
//           </div>

//           <div className="keydiff-count-box">
//             <div className="keydiff-count-value">
//               {c.sometimes}
//             </div>
//             <div className="keydiff-count-label">
//               SOMETIMES
//             </div>
//           </div>

//           <div className="keydiff-count-box">
//             <div className="keydiff-count-value">
//               {c.usually}
//             </div>
//             <div className="keydiff-count-label">
//               USUALLY
//             </div>
//           </div>

//           <div className="keydiff-count-box">
//             <div className="keydiff-count-value">
//               {c.almost_always}
//             </div>
//             <div className="keydiff-count-label">
//               ALMOST ALWAYS
//             </div>
//           </div>

//         </div>

//         <div className="keydiff-footer">
//           <span>
//             BEHAVIOR: {q.group_name.toUpperCase()}
//           </span>

//           <span>
//             AVG. SCORE: {q.average.toFixed(2)}
//           </span>
//         </div>

//       </div>
//     );
//   })}
// </div>

// {/* ================= PYRAMID ================= */}                                                                                                                                                                                                                                                                                                                     
//       <svg
//   viewBox="0 0 720 520"
//   width="520"
//   height="520"
//     preserveAspectRatio="xMidYMid meet"
//   >

//     {/* Glow filter */}
//     <defs>
//       <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
//         <feGaussianBlur stdDeviation="6" result="blur" />
//         <feMerge>
//           <feMergeNode in="blur" />
//           <feMergeNode in="SourceGraphic" />
//         </feMerge>
//       </filter>
//     </defs>

//     {pyramidConfig.map((item, i) => {
//       const avg = Number(
//         analytics[item.full]?.group_metrics?.average || 0
//       );

//       const height = 520;
//       const width = 720;
//       const bandHeight = height / 5;

//       const yTop = i * bandHeight;
//       const yBottom = (i + 1) * bandHeight;

//       const widthTop = (yTop / height) * width;
//       const widthBottom = (yBottom / height) * width;

//       const xTopLeft = (width - widthTop) / 2;
//       const xTopRight = xTopLeft + widthTop;

//       const xBottomLeft = (width - widthBottom) / 2;
//       const xBottomRight = xBottomLeft + widthBottom;

//       const gradientId = `grad-${i}`;

//       return (
//         <g key={item.full}>

//           {/* Gradient definition */}
//           <defs>
//             <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
//               {avg < 3 && (
//                 <>
//                   <stop offset="0%" stopColor="#ff6b6b" />
//                   <stop offset="100%" stopColor="#e53935" />
//                 </>
//               )}
//               {avg >= 3 && avg < 4 && (
//                 <>
//                   <stop offset="0%" stopColor="#f9d976" />
//                   <stop offset="100%" stopColor="#f4d03f" />
//                 </>
//               )}
//               {avg >= 4 && (
//                 <>
//                   <stop offset="0%" stopColor="#2ecc71" />
//                   <stop offset="100%" stopColor="#1e8449" />
//                 </>
//               )}
//             </linearGradient>
//           </defs>

//           <polygon
//             points={`
//               ${xTopLeft},${yTop}
//               ${xTopRight},${yTop}
//               ${xBottomRight},${yBottom}
//               ${xBottomLeft},${yBottom}
//             `}
//             fill={`url(#${gradientId})`}
//             stroke="white"
//             strokeWidth="4"
//             className="pyramid-slice"
//             onClick={() => setSelectedGroup(item.full)}
// style={{
//   cursor: "pointer",
//   opacity: selectedGroup && selectedGroup !== item.full ? 0.4 : 1,
//   transition: "all 0.4s ease",
//   filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.12))"
// }}
//           />

//           <text
//             x={width / 2}
//             y={yTop + bandHeight / 1.2}
//             textAnchor="middle"
//             dominantBaseline="middle"
//             fill="#ffffff"
//             fontSize="20"
//             fontWeight="700"
//             letterSpacing="1"
//             style={{
//               pointerEvents: "none"
//             }}
//           >
//             {item.short}
//           </text>
//         </g>
//       );
//     })}
//   </svg>


// {/* ================= LAYER DETAIL VIEW ================= */}
// {selectedGroup && (
//   <div style={{ marginTop: 80 }}>
//     <h2>{selectedGroup}</h2>

//     <h4>
//       YOUR TEAM'S AVERAGE SCORE:{" "}
//       {analytics[selectedGroup].group_metrics.average}
//     </h4>

//     <div style={{ marginTop: 30 }}>
//       {analytics[selectedGroup].questions.map((q, i) => {

//         const percent = (q.average / 5) * 100;

//         const barColor =
//           q.average < 3 ? "#E53935" :
//           q.average < 4 ? "#F4D03F" :
//           "#1E8449";

//         return (
//           <div key={q.question_id} style={{ marginBottom: 22 }}>
//             <div>
//               {i + 1}. {q.question_text}
//             </div>

//             <div style={{
//               background: "#e5e7eb",
//               height: 8,
//               borderRadius: 4,
//               marginTop: 6,
//               overflow: "hidden"
//             }}>
//               <div style={{
//                 width: `${percent}%`,
//                 height: "100%",
//                 background: barColor,
//                 transition: "width 0.6s ease"
//               }} />
//             </div>

//             <div style={{ textAlign: "right", marginTop: 4 }}>
//               {q.average.toFixed(2)}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   </div>
// )}

//     </div>
//   );
// }

// /* Color Legend Item */
// function LegendItem({ color, label }) {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//       <div style={{
//         width: 18,
//         height: 18,
//         backgroundColor: color
//       }} />
//       <span>{label}</span>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import axios from "axios";
import "./FiveDysfunctionPyramid.css";


const pyramidConfig = [
  { full: "Inattention to Results", short: "RESULTS" },
  { full: "Avoidance of Accountability", short: "ACCOUNTABILITY" },
  { full: "Lack of Commitment", short: "COMMITMENT" },
  { full: "Fear of Conflict", short: "CONFLICT" },
  { full: "Absence of Trust", short: "TRUST" }
];


export default function FiveDysfunctionPyramid({ surveyId, companyId }) {
  const [analytics, setAnalytics] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    fetchData();
  }, [surveyId, companyId]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/superadmin/analytics/score/${surveyId}/${companyId}`
      );
      setAnalytics(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getColor = (avg) => {
    if (avg < 3) return "#E53935";   // RED
    if (avg < 4) return "#F4D03F";   // YELLOW
    return "#1E8449";                // GREEN
  };

  if (!analytics) return <div>Loading...</div>;

  const height = 520;
  const width = 720;
  const bandHeight = height / 5;

  const getGradient = (avg) => {
  if (avg < 3)
    return "linear-gradient(90deg, #ff6b6b, #e53935)";
  if (avg < 4)
    return "linear-gradient(90deg, #f9d976, #f4d03f)";
  return "linear-gradient(90deg, #2ecc71, #1e8449)";
};

// Flatten all questions — skip the team_culture key (it has a different shape)
const allQuestions = analytics
  ? Object.entries(analytics)
      .filter(([groupName]) => groupName !== "team_culture")
      .flatMap(([groupName, groupData]) =>
        groupData.questions.map(q => ({
          ...q,
          group_name: groupName
        }))
      )
  : [];

// Top 6 strongest
const strongest = [...allQuestions]
  .sort((a, b) => b.average - a.average)
  .slice(0, 6);

// Bottom 6 weakest
const weakest = [...allQuestions]
  .sort((a, b) => a.average - b.average)
  .slice(0, 6);

const AnimatedNumber = ({ value }) => {
  const [display, setDisplay] = React.useState(0);

  React.useEffect(() => {
    let start = 0;
    const duration = 800;
    const increment = value / (duration / 16);

    const counter = setInterval(() => {
      start += increment;
      if (start >= value) {
        start = value;
        clearInterval(counter);
      }
      setDisplay(start);
    }, 16);

    return () => clearInterval(counter);
  }, [value]);

  return display.toFixed(2);
};

// ================= KEY DIFFERENCES =================

const keyDifferences = allQuestions.filter(q => {

  const c = q.counts;

  const left =
    c.almost_never +
    c.rarely;

  const right =
    c.usually +
    c.almost_always;

  const center = c.sometimes;

  const total =
    left + right + center;

  if (!total) return false;

  const leftPct = left / total;
  const rightPct = right / total;

  // Rule 1: 50/50 split
  const rule1 =
    Math.abs(leftPct - rightPct) <= 0.1;

  // Rule 2: 60/40 disagreement
  const rule2 =
    (leftPct >= 0.4 && leftPct <= 0.6) ||
    (rightPct >= 0.4 && rightPct <= 0.6);

  // Rule 3: extreme ends present
  const rule3 =
    c.almost_never > 0 &&
    c.almost_always > 0;

  // Rule 4: outliers
  const rule4 =
    (leftPct >= 0.8 && rightPct >= 0.1) ||
    (rightPct >= 0.8 && leftPct >= 0.1);

  return rule1 || rule2 || rule3 || rule4;

}).slice(0,6);

  return (
    <div style={{ marginTop: 40, width: "100%" }}>

      {/* ================= COLOR LEGEND ================= */}


      {/* ================= PYRAMID + SCORE LEGEND ================= */}
{/* <div style={{
  width: "100%",
  maxWidth: 520,
  aspectRatio: "1 / 1",
  margin: "0 auto"
}}> */}

          <div style={{
        display: "flex",
        justifyContent: "center",
        gap: 60,
        marginBottom: 20,
        fontWeight: 600,
        fontSize: 14
      }}>
        <LegendItem color="#E53935" label="LOW (LESS THAN 3)" />
        <LegendItem color="#F4D03F" label="MEDIUM (3 – 3.99)" />
        <LegendItem color="#1E8449" label="HIGH (4 & ABOVE)" />
      </div>
<div className="pyramid-dashboard">

      <div className="pyramid-left">
      {/* ===== PYRAMID ===== */}
<svg
  viewBox="0 0 720 520"
  width="520"
  height="520"
    preserveAspectRatio="xMidYMid meet"
  >

    {/* Glow filter */}
    <defs>
      <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="6" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {pyramidConfig.map((item, i) => {
      const avg = Number(
        analytics[item.full]?.group_metrics?.average || 0
      );

      const height = 520;
      const width = 720;
      const bandHeight = height / 5;

      const yTop = i * bandHeight;
      const yBottom = (i + 1) * bandHeight;

      const widthTop = (yTop / height) * width;
      const widthBottom = (yBottom / height) * width;

      const xTopLeft = (width - widthTop) / 2;
      const xTopRight = xTopLeft + widthTop;

      const xBottomLeft = (width - widthBottom) / 2;
      const xBottomRight = xBottomLeft + widthBottom;

      const gradientId = `grad-${i}`;

      return (
        <g key={item.full}>

          {/* Gradient definition */}
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              {avg < 3 && (
                <>
                  <stop offset="0%" stopColor="#ff6b6b" />
                  <stop offset="100%" stopColor="#e53935" />
                </>
              )}
              {avg >= 3 && avg < 4 && (
                <>
                  <stop offset="0%" stopColor="#f9d976" />
                  <stop offset="100%" stopColor="#f4d03f" />
                </>
              )}
              {avg >= 4 && (
                <>
                  <stop offset="0%" stopColor="#2ecc71" />
                  <stop offset="100%" stopColor="#1e8449" />
                </>
              )}
            </linearGradient>
          </defs>

          <polygon
            points={`
              ${xTopLeft},${yTop}
              ${xTopRight},${yTop}
              ${xBottomRight},${yBottom}
              ${xBottomLeft},${yBottom}
            `}
            fill={`url(#${gradientId})`}
            stroke="white"
            strokeWidth="4"
            style={{
              transition: "all 0.4s ease",
              filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.12))"
            }}
            className="pyramid-slice"
          />

          <text
            x={width / 2}
            y={yTop + bandHeight / 1.2}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            fontSize="20"
            fontWeight="700"
            letterSpacing="1"
            style={{
              pointerEvents: "none"
            }}
          >
            {item.short}
          </text>
        </g>
      );
    })}
  </svg>
  </div>

        {/* ===== SCORE LEGEND ===== */}
     {/* ===== SCORE LEGEND ===== */}
{/* ===== PREMIUM SCORE LEGEND ===== */}
 <div className="pyramid-right">
<div style={{
  minWidth: 300,
  background: "#ffffff",
  padding: "24px",
  borderRadius: 16,
  boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
  transition: "all 0.3s ease"
}}>

  {/* ===== OVERALL HEALTH BADGE ===== */}
  {(() => {
    const averages = pyramidConfig.map(item =>
      Number(analytics[item.full]?.group_metrics?.average || 0)
    );

    const overall =
      averages.reduce((a, b) => a + b, 0) / averages.length;

    const overallColor =
      overall < 3 ? "#E53935" :
      overall < 4 ? "#F4D03F" :
      "#1E8449";

    return (
      <div style={{
        textAlign: "center",
        marginBottom: 24
      }}>
        {/* <div style={{
          fontSize: 13,
          fontWeight: 600,
          opacity: 0.6,
          marginBottom: 6
        }}>
          OVERALL HEALTH
        </div> */}

        {/* <div style={{
          fontSize: 28,
          fontWeight: 800,
          color: overallColor
        }}>
          <AnimatedNumber value={overall} />
        </div> */}
      </div>
    );
  })()}

  {/* ===== SECTION SCORES ===== */}
  {pyramidConfig.map(item => {
    const avg = Number(
      analytics[item.full]?.group_metrics?.average || 0
    );

    const percentage = (avg / 5) * 100;

    return (
      <div
        key={item.full}
        style={{
          marginBottom: 18,
          padding: "10px 12px",
          borderRadius: 10,
          transition: "all 0.25s ease",
          cursor: "default"
        }}
        onMouseEnter={e =>
          (e.currentTarget.style.background = "rgba(0,0,0,0.03)")
        }
        onMouseLeave={e =>
          (e.currentTarget.style.background = "transparent")
        }
      >
        {/* Label + Value */}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 6,
          fontWeight: 600
        }}>
          <span>{item.short}</span>
          <span style={{ fontWeight: 700 }}>
            <AnimatedNumber value={avg} />
          </span>
        </div>

        {/* Progress Bar */}
        <div style={{
          height: 8,
          width: "100%",
          background: "#eee",
          borderRadius: 6,
          overflow: "hidden"
        }}>
          <div style={{
            height: "100%",
            width: `${percentage}%`,
            background: getGradient(avg),
            transition: "width 0.8s ease"
          }} />
        </div>
      </div>
    );
  })}
</div>
  </div>

      </div>

      {/* ================= STRONGEST AREAS ================= */}
<div style={{ marginTop: 60 }}>
  <h2 style={{ marginBottom: 20 }}>The Strongest Areas</h2>

  {strongest.map((q, i) => (
    <div key={q.question_id} style={{ marginBottom: 18 }}>
      <div><b>{i + 1}. {q.question_text}</b></div>

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#f3f4f6",
        padding: "6px 12px",
        marginTop: 6
      }}>
        <span>BEHAVIOR: {q.group_name}</span>
        <span>AVG SCORE: {q.average.toFixed(2)}</span>
      </div>
    </div>
  ))}
</div>

{/* ================= WEAKEST AREAS ================= */}
<div style={{ marginTop: 60 }}>
  <h2 style={{ marginBottom: 20 }}>The Weakest Areas</h2>

  {weakest.map((q, i) => (
    <div key={q.question_id} style={{ marginBottom: 18 }}>
      <div><b>{i + 1}. {q.question_text}</b></div>

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#fef2f2",
        padding: "6px 12px",
        marginTop: 6
      }}>
        <span>BEHAVIOR: {q.group_name}</span>
        <span>AVG SCORE: {q.average.toFixed(2)}</span>
      </div>
    </div>
  ))}
</div>

{/* ================= KEY DIFFERENCES ================= */}



<div style={{ marginTop: 70 }}>
  <h2 style={{ marginBottom: 25 }}>
    Key Differences
  </h2>

  {keyDifferences.map((q, i) => {

    const c = q.counts;

    return (
      <div key={q.question_id} className="keydiff-question">

        <div>
          <b>{i + 1}. {q.question_text}</b>
        </div>

        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
Number of team members in each category
</div>

        <div className="keydiff-counts">

          <div className="keydiff-count-box">
            <div className="keydiff-count-value">
              {c.almost_never}
            </div>
            <div className="keydiff-count-label">
              ALMOST NEVER
            </div>
          </div>

          <div className="keydiff-count-box">
            <div className="keydiff-count-value">
              {c.rarely}
            </div>
            <div className="keydiff-count-label">
              RARELY
            </div>
          </div>

          <div className="keydiff-count-box">
            <div className="keydiff-count-value">
              {c.sometimes}
            </div>
            <div className="keydiff-count-label">
              SOMETIMES
            </div>
          </div>

          <div className="keydiff-count-box">
            <div className="keydiff-count-value">
              {c.usually}
            </div>
            <div className="keydiff-count-label">
              USUALLY
            </div>
          </div>

          <div className="keydiff-count-box">
            <div className="keydiff-count-value">
              {c.almost_always}
            </div>
            <div className="keydiff-count-label">
              ALMOST ALWAYS
            </div>
          </div>

        </div>

        <div className="keydiff-footer">
          <span>
            BEHAVIOR: {q.group_name.toUpperCase()}
          </span>

          <span>
            AVG. SCORE: {q.average.toFixed(2)}
          </span>
        </div>

      </div>
    );
  })}
</div>

{/* ================= PYRAMID ================= */}                                                                                                                                                                                                                                                                                                                     
      <svg
  viewBox="0 0 720 520"
  width="520"
  height="520"
    preserveAspectRatio="xMidYMid meet"
  >

    {/* Glow filter */}
    <defs>
      <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="6" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {pyramidConfig.map((item, i) => {
      const avg = Number(
        analytics[item.full]?.group_metrics?.average || 0
      );

      const height = 520;
      const width = 720;
      const bandHeight = height / 5;

      const yTop = i * bandHeight;
      const yBottom = (i + 1) * bandHeight;

      const widthTop = (yTop / height) * width;
      const widthBottom = (yBottom / height) * width;

      const xTopLeft = (width - widthTop) / 2;
      const xTopRight = xTopLeft + widthTop;

      const xBottomLeft = (width - widthBottom) / 2;
      const xBottomRight = xBottomLeft + widthBottom;

      const gradientId = `grad-${i}`;

      return (
        <g key={item.full}>

          {/* Gradient definition */}
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              {avg < 3 && (
                <>
                  <stop offset="0%" stopColor="#ff6b6b" />
                  <stop offset="100%" stopColor="#e53935" />
                </>
              )}
              {avg >= 3 && avg < 4 && (
                <>
                  <stop offset="0%" stopColor="#f9d976" />
                  <stop offset="100%" stopColor="#f4d03f" />
                </>
              )}
              {avg >= 4 && (
                <>
                  <stop offset="0%" stopColor="#2ecc71" />
                  <stop offset="100%" stopColor="#1e8449" />
                </>
              )}
            </linearGradient>
          </defs>

          <polygon
            points={`
              ${xTopLeft},${yTop}
              ${xTopRight},${yTop}
              ${xBottomRight},${yBottom}
              ${xBottomLeft},${yBottom}
            `}
            fill={`url(#${gradientId})`}
            stroke="white"
            strokeWidth="4"
            className="pyramid-slice"
            onClick={() => setSelectedGroup(item.full)}
style={{
  cursor: "pointer",
  opacity: selectedGroup && selectedGroup !== item.full ? 0.4 : 1,
  transition: "all 0.4s ease",
  filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.12))"
}}
          />

          <text
            x={width / 2}
            y={yTop + bandHeight / 1.2}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            fontSize="20"
            fontWeight="700"
            letterSpacing="1"
            style={{
              pointerEvents: "none"
            }}
          >
            {item.short}
          </text>
        </g>
      );
    })}
  </svg>


{/* ================= LAYER DETAIL VIEW ================= */}
{selectedGroup && (
  <div style={{ marginTop: 80 }}>
    <h2>{selectedGroup}</h2>

    <h4>
      YOUR TEAM'S AVERAGE SCORE:{" "}
      {analytics[selectedGroup].group_metrics.average}
    </h4>

    <div style={{ marginTop: 30 }}>
      {analytics[selectedGroup].questions.map((q, i) => {

        const percent = (q.average / 5) * 100;

        const barColor =
          q.average < 3 ? "#E53935" :
          q.average < 4 ? "#F4D03F" :
          "#1E8449";

        return (
          <div key={q.question_id} style={{ marginBottom: 22 }}>
            <div>
              {i + 1}. {q.question_text}
            </div>

            <div style={{
              background: "#e5e7eb",
              height: 8,
              borderRadius: 4,
              marginTop: 6,
              overflow: "hidden"
            }}>
              <div style={{
                width: `${percent}%`,
                height: "100%",
                background: barColor,
                transition: "width 0.6s ease"
              }} />
            </div>

            <div style={{ textAlign: "right", marginTop: 4 }}>
              {q.average.toFixed(2)}
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}

    {/* ================= TEAM CULTURE ================= */}
    {analytics?.team_culture && (
      <div style={{ marginTop: 70 }}>
        <h2 style={{ marginBottom: 8 }}>Team Culture Diagnostics</h2>
        <p style={{ color: "#666", marginBottom: 36, fontSize: 14 }}>
          Responses from the Team Dynamics section of the survey
        </p>

        {/* ── Building Trust & Embracing Accountability ── frequency ranked list */}
        {["Building Trust", "Embracing Accountability"].map(groupName => {
          const group = analytics.team_culture[groupName];
          if (!group) return null;
          return (
            <div key={groupName} style={{ marginBottom: 48 }}>
              <h3 style={{ marginBottom: 20, fontSize: 17, fontWeight: 700 }}>{groupName}</h3>
              {group.questions.map(q => (
                <div key={q.question_id} style={{ marginBottom: 28 }}>
                  <div style={{ fontWeight: 600, marginBottom: 14, fontSize: 15 }}>
                    {q.question_text}
                  </div>
                  <FrequencyList options={q.options} />
                </div>
              ))}
            </div>
          );
        })}

        {/* ── Navigating Conflict ── 4-column table */}
        {analytics.team_culture["Navigating Conflict"] && (
          <div style={{ marginBottom: 48 }}>
            <h3 style={{ marginBottom: 20, fontSize: 17, fontWeight: 700 }}>Navigating Conflict</h3>
            <NavConflictTable
              questions={analytics.team_culture["Navigating Conflict"].questions}
            />
          </div>
        )}

        {/* ── Committing to Decisions & Focusing on Results ── bar chart X out of N */}
        {["Committing to Decisions", "Focusing on Results"].map(groupName => {
          const group = analytics.team_culture[groupName];
          if (!group) return null;
          return (
            <div key={groupName} style={{ marginBottom: 48 }}>
              <h3 style={{ marginBottom: 20, fontSize: 17, fontWeight: 700 }}>{groupName}</h3>
              {group.questions.map(q => (
                <div key={q.question_id} style={{ marginBottom: 28 }}>
                  <div style={{ fontWeight: 600, marginBottom: 14, fontSize: 15 }}>
                    {q.question_text}
                  </div>
                  <BarChartOptions options={q.options} total={q.total_respondents} />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    )}

    </div>
  );
}

/* Color Legend Item */
function LegendItem({ color, label }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{
        width: 18,
        height: 18,
        backgroundColor: color
      }} />
      <span>{label}</span>
    </div>
  );
}
/* ─────────────────────────────────────────────────────────────────────────
   TEAM CULTURE HELPER COMPONENTS
───────────────────────────────────────────────────────────────────────── */

/**
 * FrequencyList
 * Building Trust / Embracing Accountability style:
 * Sorted list with bold count on left, option text on right, left-border line.
 */
function FrequencyList({ options }) {
  if (!options || options.length === 0)
    return <p style={{ color: "#999", fontSize: 13 }}>No responses yet.</p>;

  return (
    <div>
      {options.map(({ option, count }, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 20,
            padding: "10px 16px",
            borderLeft: "3px solid #e5e7eb",
            marginBottom: 8,
            background: i % 2 === 0 ? "#fafafa" : "#fff",
            borderRadius: "0 6px 6px 0"
          }}
        >
          <span style={{
            minWidth: 32,
            fontWeight: 800,
            fontSize: 17,
            color: "#1a1a1a",
            textAlign: "right",
            flexShrink: 0
          }}>
            {count}
          </span>
          <span style={{ fontSize: 14, lineHeight: 1.5, color: "#333" }}>
            {option}
          </span>
        </div>
      ))}
    </div>
  );
}

/**
 * NavConflictTable
 * Navigating Conflict style:
 * Table with Behavior | Not Acceptable | Tolerable | Perfectly Acceptable | # Who Do This
 */
function NavConflictTable({ questions }) {
  if (!questions || questions.length === 0)
    return <p style={{ color: "#999", fontSize: 13 }}>No responses yet.</p>;

  const cols = ["Not Acceptable", "Tolerable", "Perfectly Acceptable"];

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{
        width: "100%",
        borderCollapse: "collapse",
        fontSize: 14
      }}>
        <thead>
          <tr style={{ background: "#f3f4f6" }}>
            <th style={thStyle("left", "220px")}>RESPONSE TO CONFLICT</th>
            {cols.map(c => (
              <th key={c} style={thStyle("center")}>{c.toUpperCase()}</th>
            ))}
            <th style={thStyle("center")}>
              # OF TEAM MEMBERS WHO ADMIT<br />THEY DO THIS AT WORK
            </th>
          </tr>
        </thead>
        <tbody>
          {questions.map((q, i) => (
            <tr key={q.question_id} style={{ background: i % 2 === 0 ? "#fff" : "#f9fafb" }}>
              <td style={tdStyle("left")}>{q.question_text}</td>
              {cols.map(c => (
                <td key={c} style={{ ...tdStyle("center"), fontWeight: 700, fontSize: 16 }}>
                  {q.options[c] ?? 0}
                </td>
              ))}
              <td style={{ ...tdStyle("center"), fontWeight: 700, fontSize: 16 }}>
                {q.who_do_this_count}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const thStyle = (align, minWidth) => ({
  padding: "12px 16px",
  textAlign: align,
  border: "1px solid #d1d5db",
  fontSize: 12,
  fontWeight: 700,
  color: "#374151",
  letterSpacing: "0.03em",
  minWidth: minWidth || "auto"
});

const tdStyle = (align) => ({
  padding: "10px 16px",
  border: "1px solid #e5e7eb",
  textAlign: align,
  verticalAlign: "top",
  color: "#111"
});

/**
 * BarChartOptions
 * Committing to Decisions / Focusing on Results style:
 * Horizontal progress bar per option with "X OUT OF N" label on right.
 */
function BarChartOptions({ options, total }) {
  if (!options || options.length === 0)
    return <p style={{ color: "#999", fontSize: 13 }}>No responses yet.</p>;

  const n = total || 0;

  return (
    <div>
      {options.map(({ option, count }, i) => {
        const pct = n > 0 ? (count / n) * 100 : 0;
        return (
          <div key={i} style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 14, marginBottom: 6, color: "#222" }}>
              {option}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{
                flex: 1,
                height: 20,
                background: "#e5e7eb",
                borderRadius: 4,
                overflow: "hidden"
              }}>
                <div style={{
                  width: `${pct}%`,
                  height: "100%",
                  background: "#1a1a1a",
                  borderRadius: 4,
                  transition: "width 0.6s ease"
                }} />
              </div>
              <span style={{
                minWidth: 100,
                textAlign: "right",
                fontWeight: 700,
                fontSize: 13,
                color: "#111",
                whiteSpace: "nowrap"
              }}>
                {count} OUT OF {n}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}